import { useMemo } from "react";

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

function startOfDay(d) {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export default function CustomCalendar({
  calYear,
  calMonth,
  onShiftMonth,
  selectedDate,
  onPickDate,
}) {
  const today = useMemo(() => startOfDay(new Date()), []);

  const { label, cells } = useMemo(() => {
    const first = new Date(calYear, calMonth, 1);
    const offset = (first.getDay() || 7) - 1;
    const daysInMonth = new Date(calYear, calMonth + 1, 0).getDate();
    const list = [];
    for (let i = 0; i < offset; i++) {
      list.push({ type: "empty", key: `e-${i}` });
    }
    for (let d = 1; d <= daysInMonth; d++) {
      const dt = new Date(calYear, calMonth, d);
      list.push({ type: "day", day: d, date: dt, key: `d-${d}` });
    }
    return {
      label: `${MONTHS[calMonth]} ${calYear}`,
      cells: list,
    };
  }, [calYear, calMonth]);

  return (
    <div className="cal-box">
      <div className="cal-head">
        <span className="cal-mlabel">{label}</span>
        <div className="cal-navs">
          <button
            type="button"
            className="cal-nav"
            onClick={() => onShiftMonth(-1)}
            aria-label="Previous month"
          >
            ‹
          </button>
          <button
            type="button"
            className="cal-nav"
            onClick={() => onShiftMonth(1)}
            aria-label="Next month"
          >
            ›
          </button>
        </div>
      </div>
      <div className="cal-dn">
        <span>Mo</span>
        <span>Tu</span>
        <span>We</span>
        <span>Th</span>
        <span>Fr</span>
        <span>Sa</span>
        <span>Su</span>
      </div>
      <div className="cal-grid">
        {cells.map((cell) => {
          if (cell.type === "empty") {
            return <div key={cell.key} className="cd cd-empty" />;
          }
          const { date, day } = cell;
          const isPast = startOfDay(date) < today;
          const isToday = startOfDay(date).getTime() === today.getTime();
          const isSel =
            selectedDate &&
            startOfDay(date).getTime() === startOfDay(selectedDate).getTime();
          let cls = "cd";
          if (isPast) cls += " cd-past";
          if (isToday) cls += " cd-today";
          if (isSel) cls += " cd-sel";
          return (
            <button
              key={cell.key}
              type="button"
              className={cls}
              disabled={isPast}
              onClick={() => !isPast && onPickDate(new Date(date))}
            >
              {day}
            </button>
          );
        })}
      </div>
    </div>
  );
}
